import { h } from 'preact'

type TopicType = {
  ideationStatus?: {
    name: string,
    bgColor: string,
    color: string
  }
}

const IdeationStatus = ({ topic }: { topic: TopicType }) => {
  if (!topic.ideationStatus) {
    return null
  }

  const { name, bgColor, color } = topic.ideationStatus

  return (
    <span
      style={{ color: color, backgroundColor: bgColor }}
      class={'pill pill_idea pill--uppercase'}>
      { name }
    </span>
  )
}

export default IdeationStatus
